export default class ClientReferralPayoutTO {
  /**
   * @type {number}
  */
  clientId = undefined;

  /**
   * @type {number}
  */
  stateId = undefined;

  /**
   * @type {array}
  */
  referrals = [];

  constructor(opts = null) {
    if (opts != null) {
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.stateId != null) {
        this.stateId = opts.stateId;
      }
      if (opts.referrals != null) {
        this.referrals = opts.referrals;
      }
    }
  }
}
